import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Group, Text, Tooltip } from "@mantine/core";
import { IconBrandFacebookFilled, IconBrandInstagram } from "@tabler/icons-react";
import { CellContext } from "@tanstack/react-table";
import { CampaignApplicationRestApi } from "src/types";

export interface CellSocialsProps extends CellContext<CampaignApplicationRestApi, unknown> { }
export const CellSocials = ({ row }: CellSocialsProps) => {
    const { t } = useTranslation(["common"]);

    const socials = [];

    if (row.original?.reviewer?.socials?.hasFb) {
        socials.push(
            <Tooltip label={`${t("reviewer_socials_fb")} / ${t("reviewer_socials_followers_count", { count: row.original.reviewer.socials.fbFollowers })}`}>
                <Group spacing="2px">
                    <IconBrandFacebookFilled key="fb" size="1.2em" />
                    <Text>
                        {row.original?.reviewer?.socials?.fbFollowers}
                    </Text>
                </Group>
            </Tooltip>
        );
    }

    if (row.original?.reviewer?.socials?.hasIg) {
        socials.push(
            <Tooltip label={`${t("reviewer_socials_ig")} / ${t("reviewer_socials_followers_count", { count: row.original.reviewer.socials.igFollowers })}`}>
                <Group spacing="2px">
                    <IconBrandInstagram key="ig" size="1.2em" />
                    <Text>
                        {row.original?.reviewer?.socials?.igFollowers}
                    </Text>
                </Group>
            </Tooltip>
        );
    }

    if (socials?.length) {
        return (
            <Group spacing="xs">
                {socials?.map((item, index) => (
                    <Fragment key={`${index}`}>
                        {index > 0 && (
                            <Text>+</Text>
                        )}
                        {item}
                    </Fragment>
                ))}
            </Group>
        );
    }

    return (
        <Text color="gray">-</Text>
    );
};

